import { reduce } from 'lodash';
import usdFormatter from './usdFormatter';

/**
 * Format billing plan payment
 *
 * @param {object} plan Billing plan.
 * @param {number} shows Number of shows.
 * @param {boolean} removeTrailingZeros Flag if to remove trailing zeros.
 * @param {string[]} selectedAddOns List of selected add-ons.
 *
 * @returns {string} Formatted plan payment details
 */
export const billingPlanFilter = (plan, shows, removeTrailingZeros, selectedAddOns = []) => {
    const multiplier = shows || 1;
    let formattedAmount = '';

    const addOnsCost = reduce(plan.addons, (cost, addOn, addOnName) => {
        return cost + (selectedAddOns.includes(addOnName) ? addOn.amount : 0);
    }, 0);

    if ('month' === plan.interval) {
        const totalCost = (plan.amount + addOnsCost) * multiplier;

        formattedAmount = usdFormatter(totalCost);
    } else {
        const monthlyCost = (plan.amount + addOnsCost) / 12;
        const totalCost = monthlyCost * multiplier;

        formattedAmount = usdFormatter(totalCost);
    }

    return removeTrailingZeros ? `${formattedAmount.replace(/\.?0+$/, '')}` : `${formattedAmount}`;
};
